import { pluralize } from "views/applications-id/components/ApplicantsTable/utils";

export const FormattedConvictions = ({
  all,
  convicted
}: {
  all: number;
  convicted: number;
}) => {
  return (
    <p className="text-content-1000">
      {convicted || 0} {pluralize("conviction", convicted)}{" "}
      <span className="text-content-100">
        ({all || 0} {pluralize("offense", all)})
      </span>
    </p>
  );
};
